import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function FAQSection({ t }) {
  const [open, setOpen] = useState(null);

  if (!t.faq) return null;

  return (
    <section id="faq" className="py-20 bg-white" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900">{t.faq.title}</h2>
        </div>
        <div className="space-y-3">
          {t.faq.items.map((item, i) => (
            <div key={i} className="border border-gray-200 rounded-xl overflow-hidden" data-testid={`faq-item-${i}`}>
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left bg-white hover:bg-gray-50 transition-colors"
              >
                <span className="font-semibold text-gray-900 pr-4">{item.q}</span>
                <ChevronDown className={`w-5 h-5 text-[#CDA34F] flex-shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && (
                <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-100 pt-4 bg-gray-50">
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
